import API from './parts/API'

export default API
